import * as R from "ramda";
export function resolvePanelGroup(unresolvedPanelGroup, language) {
  var panels = unresolvedPanelGroup.panels != null ? unresolvedPanelGroup.panels : [];
  return {
    code: unresolvedPanelGroup.code,
    panels: R.map(function (unresolvedPanel) {
      return resolvePanel(unresolvedPanel, language);
    }, panels)
  };
}
export function panelGroupApi(panelGroup) {
  return {
    panelApis: R.map(function (panel) {
      return panelApi(panel);
    }, panelGroup.panels),
    get: function get(code) {
      var result = R.find(function (panelApi) {
        return panelApi.panel.code === code;
      }, this.panelApis);

      if (result == null) {
        console.log("Panel with code '".concat(code, "' in panel group '").concat(panelGroup.code, "' not found"));
      }

      return result;
    }
  };
}
export function panelApi(panel) {
  return {
    panel: panel,
    get: function get(code) {
      var result = R.find(function (item) {
        return item.code === code;
      }, panel.items);

      if (result == null) {
        if (code === "readMore") {
          return result;
        } else {
          console.log("Item with code '".concat(code, "' in panel '").concat(panel.code, "' not found"));
          return result;
        }
      } else return result.value;
    },
    getProperty: function getProperty(code, parser) {
      var result = R.find(function (property) {
        return property.code === code;
      }, panel.properties);

      if (result == null) {
        console.log("Property with code '".concat(code, "' in panel '").concat(panel.code, "' not found"));
        return null;
      } else if (parser != null) return parser(result.value);

      return result.value;
    }
  };
}
export function getPanelGroupApi(unresolvedPanelGroup, language) {
  return panelGroupApi(resolvePanelGroup(unresolvedPanelGroup, language));
}